import 'reset-css';
import 'swiper/css';
import './scss/index.scss';
import 'react-toastify/dist/ReactToastify.css'; // Toastify CSS

import { Provider } from 'react-redux';
import { store } from './store/store';

import { ToastContainer } from 'react-toastify'; // You don't need `toast` here

import { StackNavigator } from './navigation/StackNavigator';

function App() {
  return (
    <Provider store={store}>
      <StackNavigator />

      {/* ToastContainer should be inside Provider so it can access redux if needed */}
      <ToastContainer
        // position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        // pauseOnHover
        draggable
        theme="light"
      />
    </Provider>
  );
}

export default App;


// import 'reset-css';
// import 'swiper/css';
// import './scss/index.scss';
// import { store } from './store/store';
// import { Provider } from 'react-redux';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';


// import { StackNavigator } from './navigation/StackNavigator';

// function App() {
//   return (
//     <div>
//       <Provider store={store}>
//         <StackNavigator />
//       </Provider>



//     </div>
//   );
// }

// export default App;
